const getPickupLocationIdFromCode = `
query getPickupIdFromLocation($input: getPickupIdFromLocationInput) {
  getPickupIdFromLocation(input: $input) 
}
`

const setPickupIdOnCart = `
mutation setPickupIdOnCart($input: SetPickupIdOnCartInput) {
  setPickupIdOnCart(input: $input) {
    cart {
      id
    }
  }
}`

const getStorePickupByCountry = `
query getStorePickupByCountry($ids: String) {
  getStorePickupByCountry(ids: $ids) {
    address
    city
    country
    description
    email
    is_boutique
    latitude
    longitude
    name
    phone
    region
    tags
    working_hours
    code
  }
}
`

const getStoreLocatorConfig = `query {
  getMWLocationConfig{
    defaultCity
    defaultScale
    markerIcon
    productPageImage
  }
}`

export {
  setPickupIdOnCart,
  getStorePickupByCountry,
  getPickupLocationIdFromCode,
  getStoreLocatorConfig
}
